export default {
  /**  账号密码登录登出  **/
  loginIn: `/api/dwsurvey/anon/security/login.do`,
  feishuLogin: `/api/dwsurvey/anon/security/login-feishu.do`,
  loginInPwd: `/api/dwsurvey/anon/security/login-pwd.do`,
  loginWxQrCode: `/api/dwsurvey/anon/security/wx-login-qrcode.do`,
  loginWxStatus: `/api/dwsurvey/anon/security/login-weixin.do`,
  loginSendSms: `/api/dwsurvey/anon/security/send-smscode.do`,
  register: `/api/dwsurvey/anon/security//register.do`,

  logOut: `/api/dwsurvey/anon/security/logout.do`,
  surveyFooterInfo: `/api/dwsurvey/anon/web/footer-info.do`,
  /** 问卷数据  **/
  surveyList: `/api/dwsurvey/app/survey/list.do`,
  surveyInfo: `/api/dwsurvey/app/survey/info.do`,
  surveyUpdate: `/api/dwsurvey/app/survey/survey-base-attr.do`,
  surveyCreate: `/api/dwsurvey/app/survey/add.do`,
  surveyUpState: `/api/dwsurvey/app/survey/up-survey-status.do`,
  surveyCopy: `/api/dwsurvey/app/survey/copy.do`,
  surveyDelete: `/api/dwsurvey/app/survey/delete.do`,
  surveyReport: `/api/dwsurvey/app/stats/report.do`,
  surveyAnswerList: `/api/dwsurvey/app/answer/list.do`,
  surveyAnswerInfo: `/api/dwsurvey/app/answer/info.do`,
  surveyAnswerExport: `/api/dwsurvey/app/answer/export-xls.do`,
  surveyAnswerExportSync: `/api/dwsurvey/app/answer/export-by-sync.do`,
  surveyAnswerExportLog: `/api/dwsurvey/app/answer/export-log/export-log-info.do`,
  surveyAnswerExportDownload: `/api/dwsurvey/app/answer/export-log/download-answer-xls.do`,
  surveyAnswerDelete: `/api/dwsurvey/app/answer/delete.do`,
  curUserInfo: `/api/dwsurvey/app/user/currentUser.do`,
  curUserPwdUpdate: `/api/dwsurvey/app/user/up-pwd.do`,
  saveFinishAttr: `/api/dwsurvey/app/survey/save-finish-attr.do`,
  saveAnLoginStyleAttr: `/api/dwsurvey/app/survey//save-an-login-style.do`,
  surveyAll: `/api/dwsurvey/app/design/survey-design/surveyAll.do`,

  adminUserList: `/api/dwsurvey/admin/user/list.do`,
  adminUserCreate: `/api/dwsurvey/admin/user/add.do`,
  adminUserUpdate: `/api/dwsurvey/admin/user/edit.do`,
  adminUserDelete: `/api/dwsurvey/admin/user/delete.do`,

  uploadFile: `/api/dwsurvey/up/up-file-wb.do`,
  importCascadeData: `/api/dwsurvey/app/design/qu-cascade/import-cascade-data.do`,
  cascadeDataByParentId: `/api/dwsurvey/admin/cascade/cascade-data-list.do`,

  templateList: `/api/dwsurvey/app/survey-template.do`,
  copyTemplate: `/api/dwsurvey/app/survey/copy.do`,

  allDept: `/api/dwsurvey/admin/dept/all-dept.do`,

  relDeptUser: `/api/dwsurvey/app/rel/dept-user.do`,
  addRelDept: `/api/dwsurvey/app/rel/add-dept.do`,
  addRelUser: `/api/dwsurvey/app/rel/add-user.do`,
  allRelDept: `/api/dwsurvey/app/rel/all-dept.do`,
  allUser: `/api/dwsurvey/app/rel/user.do`,

  dwTaskList: `/api/dwsurvey/app/task/task.do`,
  dwSurveyMyAnswerList: `/api/dwsurvey/app/task/answer-surveys.do`
}



// WEBPACK FOOTER //
// ./src/api/index.js